import { render, staticRenderFns } from "./matchTheFollowingCard.vue?vue&type=template&id=3249dbe6&scoped=true"
import script from "./matchTheFollowingCard.vue?vue&type=script&lang=js"
export * from "./matchTheFollowingCard.vue?vue&type=script&lang=js"
import style0 from "./matchTheFollowingCard.vue?vue&type=style&index=0&id=3249dbe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249dbe6",
  null
  
)

export default component.exports